<template>
  <div>
    <el-card shadow="always">
      <el-page-header title="Home" @back="$router.push({ name: 'home' })"
        :content="$t('coletar-postagens')"></el-page-header>
    </el-card>
    <br />
    <el-card>
      <!-- <span>Selecione a ordem de serviço:</span>
      <el-row style="margin: 10px 0;">
        <div>
          <el-col :gutter="5" :xs="24" :sm="10" :md="12" :lg="6" :xl="6">
            <span>Numero da OS</span>
            <el-select ref="driver" v-model="Selected" clearable filterable collapse-tags multiple v-loading="loading"
              :disabled="disabled ? true : false" :placeholder="$t('selecione-uma-opcao')" @change="update()">
              <el-option v-for="row of ordersServices" :key="row.id" :label="row.number" :value="row"></el-option>
            </el-select>
          </el-col>
          <el-col :gutter="5" :xs="24" :sm="10" :md="12" :lg="10" :xl="10" style="margin-left: 5px;">
            Motorista
            <el-input></el-input>
          </el-col>
        </div>

      </el-row> -->
      <el-row type="flex">
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-input :placeholder="$t('etiqueta')" prefix-icon="el-icon-plus" v-on:keyup.native.enter="add()"
            v-model="tag"></el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button type="primary" icon="el-icon-plus" @click="add()">{{ $t("adicionar") }}</el-button>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="12" :xl="6">
          <span> Total de etiquetas adicionadas : {{ tableData.length }} </span>
        </el-col>
      </el-row>
      <el-table :data="tableData" stripe :default-sort="{ prop: 'tag', order: 'ascending' }">
        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" :disabled="scope.row.status === 'wait'"
              @click="remove(scope.row.tag)" circle></el-button>
          </template>
        </el-table-column>
        <el-table-column sortable prop="tag" :label="$t('etiqueta')">
          <template slot-scope="scope">
            {{ scope.row.tag }}
            &nbsp;
            <i v-if="scope.row.status === 'wait'" class="el-icon-loading"></i>
            <i style="color: #67C23A" :title="scope.row.record ? scope.row.record.customers.companyname : ''"
              v-else-if="scope.row.status === 'success'" class="el-icon-check"></i>
            <i style="color: #F56C6C" v-else class="el-icon-close"></i>
          </template>

        </el-table-column>
      </el-table>
      <div class="bottom clearfix">
        <el-button icon="el-icon-check" type="success" @click="save">Receber</el-button>
      </div>
    </el-card>

  </div>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import { CollectedService } from "@/services/customers/collected.services";
import { PrepostService } from "@/services/customers/prepost.services";

export default {
  name: "ReceiveMerchandise",
  methods: {
    add() {
      const vm = this;
      if (!vm.tag) {
        return vm.$message({
          type: "error",
          message: i18n.tc("etiqueta-nao-informada"),
        });
      }
      const tagIndex = vm.tableData.findIndex(x => x.tag === vm.tag);
      if (tagIndex !== -1) {
        vm.tag = '';
        return vm.$message({
          type: "error",
          message: i18n.tc("etiqueta-ja-relacionada"),
        });
      }
      vm.tableData.push({ tag: vm.tag, status: 'wait', record: null });
      vm.fetch(vm.tag);
      vm.tag = '';
    },

    fetch(tag) {
      const vm = this;
      const index = vm.tableData.findIndex(x => x.tag === tag);
      PrepostService.tag(tag)
        .then((response) => {
          vm.tableData[index].status = 'success';
          vm.tableData[index].record = response;
        })
        .catch(() => {
          vm.tableData[index].status = 'danger';
        })
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      CollectedService.add(vm.tableData.map(x => x.tag))
        .then(() => {
          vm.tableData = [];
          this.$message({
            type: "success",
            message: "Coletadas realizadas com sucesso!",
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    remove: function (tag) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-etiqueta", { id: tag }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const tagIndex = vm.tableData.findIndex(item => item.tag === tag);
        if (tagIndex !== -1) vm.tableData.splice(tagIndex, 1);
      });
    },
  },
  data() {
    return {
      tag: "",
      loading: false,
      tableData: [],
      ordersServices: [],
      orderServiceSelected: undefined
    };
  },
};
</script>
